<template>
    <div class="block-bg-border block-bg-border-max-mob max-mob:mt-5 mt-8 p-5 max-mob:p-4">
        <div class="uppercase app-text-lg">
            Protected Campaigns
        </div>

        <div class="pt-2 app-text-xs">
            Add campaigns to protect them from unwanted VoIP carriers
        </div>

        <CustomDivider class="my-4" />

        <CampaignsList
            :items="campaigns"
            :readonly="!editVoipShieldPermission"
            @onSelectItem="onOpenDeleteDialog"
        >
            <AddCampaignMenu
                v-if="editVoipShieldPermission"
                :items="campaignsAvailable"
                @onAdd="onAdd"
            />
        </CampaignsList>
    </div>

    <ConfirmDialog
        v-model="showConfirmDialog"
        :item="selectedItem"
        :loading="actionLoading"
        classWrap="max-w-100 max-mob:max-w-full min-w-99.5 max-mob:min-w-full"
        title="Detach Campaign"
        subTitle="Are you sure you want to detach this Campaign from the VoIP Shield?"
        prop
        :confirmButtons="['Cancel', 'Confirm']"
        @submitForm="detachCampaign"
    >
        <template #content="{ item }">
            <div class="h-7.5 flex items-center">
                <div class="-ml-2.5 flex">
                    <CountryFlag
                        class="rounded-0.5 normal-size__dropdown"
                        :country="item.country.code"
                    />
                </div>

                <div class="text-xs text-gray-370 dark:text-white truncate">
                    {{ item.name }}
                </div>
            </div>
        </template>
    </ConfirmDialog>
</template>

<script setup>
import { computed, ref } from 'vue'

import CustomDivider from '@/components/divider/CustomDivider.vue'
import CampaignsList from '@/components/lists/Campaigns/CampaignsList.vue'
import AddCampaignMenu from '@/components/menu/AddCampaignMenu/AddCampaignMenu.vue'
import ConfirmDialog from '@/components/dialogs/ConfirmDialog.vue'

import { useDetailVoipShieldStore } from '@/store/call-tracking/suppressionList/detailVoipShieldStore'
import { usePermissionsStore } from '@/store/permissionsStore'

const detailVoipShieldStore = useDetailVoipShieldStore()
const permissionsStore = usePermissionsStore()

const editVoipShieldPermission = computed(() => permissionsStore.permissions.voipShield.edit)

const actionLoading = computed(() => detailVoipShieldStore.actionLoading)
const campaigns = computed(() => detailVoipShieldStore.campaigns)
const campaignsAvailable = computed(() => detailVoipShieldStore.campaignsAvailable)

const showConfirmDialog = ref(false)
const selectedItem = ref({})

function onAdd(item) {
    detailVoipShieldStore.goToAttachCampaign(item)
}

function onOpenDeleteDialog(item) {
    showConfirmDialog.value = true

    selectedItem.value = item
}

async function detachCampaign(item) {
    const { success } = await detailVoipShieldStore.goToDetachCampaign(item)

    if (success) {
        showConfirmDialog.value = false
    }
}
</script>
